import { gql } from 'graphql-request'

import graphQLRequest from '@/CandidateExperience/config/graphQLRequest'

const FETCH_RECOMMENDED_JOBS = gql`
  query recommendedJobs($candidateProfileId: ID!, $offset: Int, $limit: Int, $searchString: String) {
    recommendedPositionCards(candidateProfileId: $candidateProfileId, limit: $limit, offset: $offset, searchString: $searchString) {
      totalCount
      nodes {
        id
        name
        companyProfileId
        companyProfileName
        companyProfileSlug
        companyProfileBrandColor
        companyProfileImage
        roleExperience {
          role {
            name
          }
          yearsExperience
        }
        otherRoles {
          id
          name
        }
        mustHaveSkillExperiences {
          id
          skill {
            name
          }
          yearsExperience
        }
        niceToHaveSkills {
          id
          name
        }
        workplacePolicy {
          type
          comprehensiveLocations {
            displayAddress
          }
        }
        remunerationPeriod
        publishedSalaryRange {
          start
          end
        }
        currency {
          code
        }
      }
    }
  }
`

export const fetchRecommendedJobs = ({ candidateProfileId, offset, limit, searchTerms }) => {
  return graphQLRequest(FETCH_RECOMMENDED_JOBS, { candidateProfileId, offset, limit, searchString: searchTerms })
}
